import type { ReactElement } from 'react';
import React, { Fragment, memo } from 'react';
import { Popover, Space } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import type { CReactNode } from '@bluevision/tools';
import { isNum, isStr, placeholder } from '@bluevision/tools';
import { useTranslation } from 'react-i18next';

import CopyableText from '../CopyableText';

type Props = {
  value: string[] | string;
  text?: CReactNode;
  render?: (x: string | number) => ReactElement;
};

const MultipleRender: React.FC<Props> = (props) => {
  const { value, text = '', render } = props;

  const { t } = useTranslation();

  const renderItem: Props['render'] = (x) => {
    return render ? render(x) : <CopyableText value={x} />;
  };

  return isStr(value) || isNum(value) ? (
    renderItem(value as string)
  ) : (
    <Fragment>
      {value?.length > 0 ? (
        value?.length === 1 ? (
          renderItem(value[0])
        ) : (
          <Popover
            content={
              <ul className='noPaddingUl noMargin' onClick={(e) => e.stopPropagation()}>
                {(value as string[]).map((x) => (
                  <li key={x} style={{ wordBreak: 'break-all' }}>
                    {renderItem(x as string)}
                  </li>
                ))}
              </ul>
            }
            trigger='hover'
            placement='topLeft'
          >
            <Space>
              <span>
                {value.length}
                {text && (typeof text === 'string' ? t(text) : text)}
              </span>
              <InfoCircleOutlined style={{ color: '#BEC4D4' }} />
            </Space>
          </Popover>
        )
      ) : (
        placeholder
      )}
    </Fragment>
  );
};

export default memo(MultipleRender);
